import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-heading font-semibold text-foreground-900 mb-3">
            分类未找到
          </h1>
          <Link
            to="/"
            className="text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const canonicalUrl = `${window.location.origin}${__BASE_PATH__}/category/${slug}`;

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 大胸姐妹指南`,
          description: category.description,
          url: canonicalUrl,
          inLanguage: 'zh-CN',
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
              <Breadcrumb
                items={[
                  { label: '首页', to: '/' },
                  { label: category.name },
                ]}
              />
              <div className="mt-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${category.icon} text-lg`}></i>
                  </div>
                  <h1 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900">
                    {category.name}
                  </h1>
                </div>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
                  {category.description}
                </p>
              </div>
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {articles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无相关文章</p>
              </div>
            )}

            <div className="mt-12 border-t border-background-200/70 pt-8">
              <h2 className="text-base font-semibold text-foreground-900 mb-4">
                浏览其他分类
              </h2>
              <div className="flex flex-wrap gap-2">
                {categories
                  .filter((c) => c.slug !== slug)
                  .map((c) => (
                    <Link
                      key={c.slug}
                      to={`/category/${c.slug}`}
                      className="px-3 py-1.5 text-xs rounded-full bg-secondary-50 text-secondary-700 border border-secondary-200 hover:bg-secondary-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {c.name}
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}